export const BUTTON_LOADING_TIME = 2000;